import { render, staticRenderFns } from "./DataInputAutocomplete.vue?vue&type=template&id=1b774482&scoped=true&"
import script from "./DataInputAutocomplete.vue?vue&type=script&lang=js&"
export * from "./DataInputAutocomplete.vue?vue&type=script&lang=js&"
import style0 from "./DataInputAutocomplete.vue?vue&type=style&index=0&id=1b774482&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b774482",
  null
  
)

export default component.exports